export default __webpack_public_path__ + "78121ab.png";